<div class="videos p-b-medium-big">
    <div class="videos-wrapper" id="videos">
        <ng-container *ngIf="!showVideoModal" id="videosWrapper">
            <div class="video-card" *ngFor="let video of videosList[videoPage]">
                <div class="card-upheader m-b-lg-small">{{video?.header}}</div>
                <div class="card-header m-b-xs-small m-b-lg-regular">{{video?.title}}</div>
                <div class="card-button m-b-xs-small m-b-lg-regular" (click)="videoOnClick(video)">Watch video.</div>
                <div class="card-video">
                    <app-video-player [isArticle]="false" [content]="video" [isDisabled]="true" (click)="videoOnClick(video)"></app-video-player>
                </div>
            </div>
        </ng-container>
        <div class="videoModal" *ngIf="showVideoModal" id="videoModal">
            <div class="videoModal__wrapper">
                <div class="close" (click)="closeModal()"><span class="icon icon_cross-light"></span></div>
                <app-video-player [isArticle]="false" [content]="selectedVideo" [modalVideo]="true"></app-video-player>
            </div>
        </div>
    </div>
     <app-component-controls *ngIf="breakpoints.large || breakpoints.extralarge" [navigationStyle]="'dots'" [currentIndex]="videoPage" [cutBy]="4" [elements]="videos" [watchElementId]="'videos'" [animation]="'fade'" (elementsListEvent)="videosList = $event"
        (navigateToEvent)="onNavigate($event)"></app-component-controls>
    <app-component-controls *ngIf="breakpoints.small || breakpoints.extraSmall" [navigationStyle]="'dots'" [currentIndex]="videoPage" [cutBy]="2" [elements]="videos" [watchElementId]="'videos'" [animation]="'slide'" (elementsListEvent)="videosList = $event" (navigateToEvent)="onNavigate($event)"></app-component-controls>
</div>
